import { render, staticRenderFns } from "./EmployeeBenefits.vue?vue&type=template&id=55079cd8&scoped=true"
import script from "./EmployeeBenefits.vue?vue&type=script&lang=js"
export * from "./EmployeeBenefits.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBenefits.vue?vue&type=style&index=0&id=55079cd8&prod&lang=scss"
import style1 from "./EmployeeBenefits.vue?vue&type=style&index=1&id=55079cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55079cd8",
  null
  
)

export default component.exports